import axios from "axios";
import { MKS_BACKEND_URL } from "src/utils/env";
import { GlobalUtils } from "src/utils/globalUtils";
import { mapProfileToUpdatePayload } from "src/utils/profileMapper";
import type { ProfileDto } from "src/types/Profile";

const BASE_URL = MKS_BACKEND_URL;

export const ProfileService = {
  async getProfile(emailId: string): Promise<ProfileDto> {
    const token = GlobalUtils.getToken();
    const res = await axios.get(`${BASE_URL}/profile`, {
      params: { emailId },
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    });
    return res.data as ProfileDto;
  },

  async updateProfile(emailId: string, updatedData: ProfileDto): Promise<ProfileDto> {
    const token = GlobalUtils.getToken();
    const payload = mapProfileToUpdatePayload(updatedData);
    await axios.put(`${BASE_URL}/profile/update/${encodeURIComponent(emailId)}`, payload, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    });
    return await this.getProfile(emailId);
  },

  async addFamilyMember(ownerEmailId: string, memberData: { memberName: string; relation: string; email?: string | null; mobileNo?: string | null }): Promise<string> {
    const token = GlobalUtils.getToken();
    const url = `${BASE_URL}/profile/add-member/${encodeURIComponent(ownerEmailId)}`;
    const response = await axios.post(url, memberData, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    });
    return typeof response.data === "string" ? response.data : (response.data?.Message || response.data?.message || "Member added successfully");
  },

  async updateFamilyMember(memberId: number, memberData: { id?: number; memberName?: string; relation?: string; email?: string | null; mobileNo?: string | null }): Promise<string> {
    const token = GlobalUtils.getToken();
    const url = `${BASE_URL}/profile/member/${memberId}`;
    const payload = { id: memberId, ...memberData };
    const response = await axios.put(url, payload, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    });
    if (typeof response.data === "string") return response.data;
    return response.data?.Message || "Member updated successfully";
  },
};

export {};
